import { setSpecialOfferQualified } from "@/utils/cookie-detection"

import Cookies from "js-cookie"

const LS_TRACKING_KEY = "discount_tracking"
const LS_COOLDOWN_KEY = "discount_cooldown"
const SESSION_EXPIRY_MINUTES = 30 * 60 * 1000
export const ENGAGED_DISCOUNT_CODE = "INTRO20"
export const ENGAGED_DISCOUNT_VALUE = 20

const now = Date.now()
const MS_IN_DAY = 864e5
const COOLDOWN_DAYS = 60
const COOLDOWN_IN_MS = now + COOLDOWN_DAYS * MS_IN_DAY

const getTrackingData = () => {
  const raw = localStorage.getItem(LS_TRACKING_KEY)
  return raw
    ? JSON.parse(raw)
    : {
        sessions: [],
        pages: [],
      }
}

const saveTrackingData = data => {
  localStorage.setItem(LS_TRACKING_KEY, JSON.stringify(data))
}

const isNewSession = () => {
  const lastSessionTime = parseInt(
    sessionStorage.getItem("lastSessionTime") || "0",
    10,
  )
  const isNew =
    !lastSessionTime || now - lastSessionTime > SESSION_EXPIRY_MINUTES

  sessionStorage.setItem("lastSessionTime", now.toString())

  return isNew
}

const isInCooldown = () => {
  const cooldownDate = localStorage.getItem(LS_COOLDOWN_KEY)
  return cooldownDate && now < parseInt(cooldownDate, 10)
}

export const runDiscountTracking = () => {
  if (isInCooldown()) {
    return
  }

  const data = getTrackingData()

  if (isNewSession()) {
    data.sessions.push(`sess_${now}`)
  }

  const page = window.location.pathname

  if (!data.pages.includes(page)) {
    data.pages.push(page)
  }

  saveTrackingData(data)

  const hasExistingDiscount = !!Cookies.get("exp_offer")
  const hasVisitedSignupPage = data.pages.includes("/signup/")
  const hasVisitedEnoughPages = data.pages.length >= 3
  const hasEnoughSessions = data.sessions.length >= 2

  const qualifiesForEngagedDiscount =
    !hasExistingDiscount &&
    hasVisitedSignupPage &&
    hasVisitedEnoughPages &&
    hasEnoughSessions

  if (qualifiesForEngagedDiscount) {
    setSpecialOfferQualified(ENGAGED_DISCOUNT_CODE)

    localStorage.setItem(LS_COOLDOWN_KEY, COOLDOWN_IN_MS.toString())
    localStorage.removeItem(LS_TRACKING_KEY)
    sessionStorage.removeItem("lastSessionTime")
  }
}
